import React from "react";
import styles from "./OnlyDropDown.module.css";

const OnlyDropDown = ({
  label = "Choose",
  value = "",
  options = [],
  onChange = () => {},
  required = false,
  name = "",
}) => {
  const isPlaceholder = value === "";

  return (
    <div className={styles.inputBlock}>
      <select
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className={`${styles.inputField} ${
          isPlaceholder ? styles.placeholder : ""
        }`}
      >
        <option value="" disabled hidden>
          {label}
        </option>
        {options.map((opt, index) => (
          <option key={index} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default OnlyDropDown;
